<template>
    <div class="sign-page">
        <div class="sign-page__content">
            <div class="container h-100">
                <div class="layout wrap justify-center">
                    <div class="flex xs12 sm12 md12 lg12 xl9">
                        <div class="sign-page__top text-center">
                            <logo :width="175" :height="40"/>
                        </div>

                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>

        <section-footer class="sign-page__footer" :isLight="true" :isMember="true"/>
    </div>
</template>

<script>
    import footer from '@/components/studios/StudioFooter';

    export default {
        components: {
            'section-footer': footer
        }
    }
</script>

<style lang="sass" scoped>
.sign-page
    color: $color--white
    background-image: url('../assets/images/clients/login-bg.jpg')
    +cover
    position: relative
    height: 100%
    display: flex
    flex-direction: column
    &:before
        content: ''
        display: block
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background: linear-gradient(266.29deg, rgba(6, 30, 71, 0.78) 2.21%, rgba(23, 66, 124, 0.64) 135.57%)
    .container
        z-index: 3
        height: 100%
        position: relative
        padding-top: 40px
        display: flex
        flex-direction: column
        padding-bottom: 50px
        +r(1023)
            padding-top: 28px
    .layout
        flex: 1
        position: relative
    &__content
        flex: 1
    &__top
        margin-bottom: 20px
        +r(1023)
            margin-bottom: 0
            text-align: left !important

            .logo
                width: 104px
                height: 24px

        +r(599)
            margin-bottom: 48px

            .logo
                width: 70px
                height: 16px

    &__footer
        flex-shrink: 0
        position: relative
        z-index: 11
        padding: 16px

    +r(599)
        background-color: $color--dark
        background-image: none

        &::before
            background: none
</style>